export var DOMAIN = 'localhost';
export var PORT = 8080;
export var BASE_ENDPOINT = '/api';
export var TIMEOUT = 60000;
export var HEADERS = {
    'Content-Type': 'application/json',
};
export var ENDPOINTS = {
    LOGIN: '/login',
    LOGOUT: '/logout',
    GET: '/get',
    EXECUTE: '/execute',
    INSTALL: '/install',
    CHOICE_GROUP: '/choiceGroup',
    DOWNLOAD: '/download',
    UNSUBSCRIBE: '/unsubscribe',
};
//# sourceMappingURL=defaults.js.map